module.exports = __webpack_public_path__ + "img/paperplane.88c684b3.png";